<!--====================================
=            CHARTAREAAPEX2            =
=====================================-->

<template><div justify center >
    <div id="chart-area"></div>
  </div>
</template>
<script>
export default {
  mounted() {
    var options = {
      chart: {
        height: 260,

        type: "area",
        toolbar: {
          show: false
        }
      },
      series: [
        {
          name: "Series 1",
          data: [45, 52, 38, 45, 19, 23, 2]
        }
      ],
      colors: ["#836bf7"],
      fill: {
        type: "pattern",
        gradient: {
          shadeIntensity: 1,
          opacityFrom: 0.7,
          opacityTo: 0.9,
          stops: [0, 90, 100]
        }
      },
      xaxis: {
        categories: [
          "01 Jan",
          "02 Jan",
          "03 Jan",
          "04 Jan",
          "05 Jan",
          "06 Jan",
          "07 Jan"
        ]
      }
    }; // eslint-disable-next-line no-undef
    // eslint-disable-next-line no-redeclare
    var chart = new ApexCharts(document.querySelector("#chart-area"), options);

    chart.render();
  }
};
</script>
<!--====  End of CHARTAREAAPEX2  ====-->
